import { ButtonTypes } from "../../../../../../components/ui/Button";
import { Icon, IconSymbols } from "../../../../../../components/ui/Icon";
import { UiSizes } from "../../../../../../enums";
import I18n from "../../../../../localization/I18n";
import { UiActionRenderers } from "../../../../../uiAction/IUiAction";
import { GridActionEnum, GridLinkActionEnum } from "../../../enums/GridActionEnum";
import { ImpactGroupsGridViewModel } from "./ImpactGroupsGridView_model";

export const GetImpactGroupGridActions = (model: ImpactGroupsGridViewModel) => {
  return [
    {
      id: "name",
      label: I18n.t("phrases.add"),
      componentProps: {
        symbol: IconSymbols.Plus
      },
      type: "microForm",
      contextProps: {
        formModel: model.microImpactGroupForm,
        onSubmit: model.createMicroImpactGroup
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.review,
      label: I18n.t("phrases.review"),
      type: "uiAction",
      onAction: ev => model.showImpactConfirmReviewModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.CommentPencil
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.link,
      label: (
        <>
          <Icon symbol={IconSymbols.Link} size={UiSizes.MD} />
          <Icon symbol={IconSymbols.ChevronDown} size={UiSizes.SM} />
        </>
      ),
      type: "uiAction",
      componentProps: {
        type: ButtonTypes.LINK,
        className: "p-1"
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON,
      children: [
        {
          id: GridLinkActionEnum.linkImpacts,
          label: I18n.t("phrases.linkImpacts"),
          type: "uiAction",
          onAction: ev => model.showLinkToImpacts(),
          componentProps: {
            type: ButtonTypes.LINK,
            symbol: IconSymbols.Link
          },
          disabledWhenNoItemSelected: true,
          rendersIn: UiActionRenderers.BUTTON
        }
      ]
    },
    {
      id: GridActionEnum.delete,
      label: I18n.t("phrases.delete"),
      type: "uiAction",
      onAction: ev => model.showImpactConfirmDeleteModal(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Trash
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.duplicate,
      label: I18n.t("phrases.duplicate"),
      type: "uiAction",
      onAction: ev => model.duplicateItems(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Copy
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.export,
      label: I18n.t("phrases.export"),
      type: "uiAction",
      onAction: ev => model.exportRows(),
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.Download
      },
      disabledWhenNoItemSelected: true,
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: "devider",
      label: "",
      type: "devider",
      onAction: ev => {},
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.textWrap,
      label: I18n.t("phrases.textWrap"),
      type: "uiAction",
      onAction: ev => {
        model.textWrapAddon.toggleTextWrap();
        model.generateActions();
      },
      componentProps: {
        type: model.textWrapAddon.isWrappedText ? ButtonTypes.PRIMARY : ButtonTypes.OUTLINE_PRIMARY,
        symbol: IconSymbols.TextWrap
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.clearFilters,
      label: I18n.t("phrases.clearFilters"),
      type: "uiAction",
      disabledWhenNoItemSelected: false,
      onAction: ev => {
        model.filterStoreAddon.clearFilters();
      },
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.ClearFilter,
        isDisabled: !model.isFilterChanged
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    },
    {
      id: GridActionEnum.resetColumns,
      label: I18n.t("phrases.resetColumns"),
      type: "uiAction",
      disabledWhenNoItemSelected: false,
      onAction: ev => {
        model.columnStateAddon.resetColumns();
      },
      componentProps: {
        type: ButtonTypes.LINK,
        symbol: IconSymbols.MonitorBack,
        isDisabled: !model.isColumnStateChanged
      },
      rendersIn: UiActionRenderers.BUTTON_ICON
    }
  ];
};
